<template>
  <span class="hcl-tiles-editor-chooser-content-from-element">{{ entity.field.title }}</span>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'

import { DefinitionFormField, DefinitionTile } from '@/components/types'

interface Props {
  /**
   * Definition as an JS object.
   */
  tile: DefinitionTile
}

const props = withDefaults(defineProps<Props>(), {
  tile: undefined
})

const definitionFields: any[] | undefined = inject('definitionFields')

const entity = computed(() => {
  const f = definitionFields?.filter((field: DefinitionFormField) => {
    return field.field.name === props.tile.entity.name
  })

  return f ? f[0] : {}
})
</script>
